import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, useForm } from "react-hook-form";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import {
  TransactionServiceFormRule,
  TransactionServiceFormSchema,
} from "@factory/form/form.rule";
import { transactionServiceFormDefault } from "@factory/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import { useQyCreateTransactionService } from "@factory/query/transaction-service.query";

export function useNewTransactionService() {
  // LOCAL DECLARATION
  const { getUserRole } = useUserIdentityContext();
  const navigate = useNavigate();
  const { mapCreateTransactionService } = useFormApiMapper();
  const { showError, showSuccess } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Service is created`);
  };
  const { mutate: addTransactionService, isLoading: isCreating } =
    useQyCreateTransactionService(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<TransactionServiceFormSchema>({
    defaultValues: transactionServiceFormDefault,
    resolver: zodResolver(TransactionServiceFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: TransactionServiceFormSchema) => {
    const { tenant } = getUserRole();

    const formData = mapCreateTransactionService(form);
    addTransactionService(formData);
  };
  const handleValidateError = (
    err: FieldErrors<TransactionServiceFormSchema>
  ) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
